// @flow

import type {Page} from 'types';

import {useMatch} from 'react-router-dom';

import {PAGE_CHECKOUT, PAGE_CONFIRM, ROUTES} from 'consts';

// $FlowIgnore
export const useCurrentPage = (): Page => {
  const checkoutPageMatch = useMatch(ROUTES.checkoutPage);
  const confirmPageMatch = useMatch(ROUTES.confirmPage);

  if (checkoutPageMatch) {
    return PAGE_CHECKOUT;
  }
  if (confirmPageMatch) {
    return PAGE_CONFIRM;
  }
};
